import { DateTime } from 'luxon';

export const dayToMonth = (time: number): string => {
  const month = [
    'січня',
    'лютого',
    'березня',
    'квітня',
    'травня',
    'червня',
    'липня',
    'серпня',
    'вересня',
    'жовтня',
    'листопада',
    'грудня',
  ];

  return month[time];
};

export function getWeekDay(date: number) {
  let days = ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
  return days[date];
}

export const dateNormalize = (date: string) => {
  const now = DateTime.local().setLocale('uk');
  const current = DateTime.fromFormat(date, 'yyyy-LL-dd').setLocale('uk');

  if (now.toFormat('yyyy-LL-dd') === current.toFormat('yyyy-LL-dd')) {
    return 'Сьогодні';
  }

  if (now.plus({ days: 1 }).toFormat('yyyy-LL-dd') === current.toFormat('yyyy-LL-dd')) {
    return 'Завтра';
  }

  return `${current.toFormat('cccc')}<span>${current.toFormat('d MMMM')}</span>`;
};
